export default {
  QUIZZES_LOAD: 'QUIZZES_LOAD',
  QUIZZES_FETCHED: 'QUIZZES_FETCHED',
  QUIZ_CHOSEN: 'QUIZ_CHOSEN',
};
